module.exports = __webpack_public_path__ + "img/gaib.e2b6add9.svg";